<template>
  <my-header></my-header>
  <div class="product-list-body">
    <div class="product-page-title-body">
      <div class="product-page-title"><h5>{{ $t('nav.home') }} > {{ pageTitle }}</h5></div>
    </div>
    <div class="list-title">
      <h3>{{ currentPdt.name }}</h3>
      <h6>{{ $t('pageTitles.patentNumber') }}: {{ currentZL }}</h6>
    </div>
    <div class="pdt-image-body">
      <div class="body-left">
        <div class="pdt-image-show">
          <image-view :images="imageList" :imgId="imageId"></image-view>
        </div>
        <div class="pdt-image-mini">
          <img
              v-for="url in imageList"
              :key="url.id"
              :src="url.src"
              class="xiaotu"
              @click="qiehuanImage(url.id)"
          >
        </div>
      </div>
      <!-- 替换原有的body-right区域 -->
      <div class="body-right">
        <div class="video-container">
          <!-- 视频播放器 -->
          <video
              :src="currentVideoUrl"
              class="product-video"
              controls
              poster="../assets/blogo.png"
              playsinline
          >
          </video>
        </div>
      </div>
    </div>

    <!-- 新增产品详情描述区域 -->
    <div class="product-detail-section">
      <div class="detail-title">
        <h3>{{ $t('pageTitles.productDetails') }}</h3>
      </div>
      <div class="detail-content">
        <div class="basic-info">
          <h4>{{ $t('pageTitles.basicInformation') }}</h4>
          <p>{{ productDescription }}</p>
        </div>
        <div class="technical-specs">
          <h4>{{ $t('pageTitles.technicalSpecifications') }}</h4>
          <table>
            <thead>
            <tr>
              <th>{{ $t('pageTitles.parameterName') }}</th>
              <th>{{ $t('pageTitles.parameterValue') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in techSpecs" :key="index">
              <td>{{ item.name }}</td>
              <td>{{ item.value }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="application-scenarios">
          <h4>{{ $t('pageTitles.applicationScenarios') }}</h4>
          <ul>
            <li v-for="(scenario, index) in applicationScenarios" :key="index">
              {{ scenario }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 新增：产品配件展示模块（修复v-if判断反转问题） -->
    <div v-if="currentAccessories.length > 0" class="product-accessories-section">
      <div class="detail-title">
        <h3>{{ $t('pageTitles.relatedAccessories') }}</h3>
      </div>
      <div class="accessories-content">
        <div class="accessory-grid">
          <div v-for="accessory in currentAccessories" :key="accessory.id" class="accessory-item">
            <div class="accessory-image">
              <img :src="accessory.image" alt="Accessory image">
            </div>
            <div class="accessory-info">
              <h4>{{ accessory.name }}</h4>
              <p>{{ accessory.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="no-accessories">
      <p>{{ $t('noRelated') }}</p>
    </div>

    <!-- 新增悬浮询盘按钮（右侧固定） -->
    <div class="floating-inquiry-btn" @click="goInquire">
      <span class="icon">&#9993;</span>
      <span class="text">{{ $t('pageTitles.goInquire') }}</span>
    </div>

  </div>
  <my-foot></my-foot>
</template>

<script>
import MyHeader from "@/components/MyHeader";
import MyFoot from "@/components/MyFoot";
import ImageView from '@/components/ImageView';
import router from '@/router';

export default {
  name: "PdtDesc",
  components: {
    MyHeader,
    MyFoot,
    ImageView
  },
  data() {
    return {
      pageTitle: "FULL LIGHT BARS",
      currentCateName: "Mini Light Bars",
      currentCateDes: "Our mini light bars comes in sizes of 18-27 inches, making it easy to install and occupying a compact space.",
      xilieNames: ["Linear Series", "TIR Series"],
      pdtImage: require('@/assets/test1.jpeg'),
      pdtName: "SY-001 TIR 18\" Mini Led Light Bar",
      imageList: [
        { src: require('@/assets/test1.jpeg'), thumbnail: require('@/assets/test1.jpeg'), id: 0 },
        { src: require('@/assets/product/47T-W.png'), thumbnail: require('@/assets/product/47T-W.png'), id: 1 },
        { src: require('@/assets/product/36T1.webp'), thumbnail: require('@/assets/product/36T1.webp'), id: 2 },
        { src: require('@/assets/product/47T-W.png'), thumbnail: require('@/assets/product/47T-W.png'), id: 3 },
        { src: require('@/assets/product/36T1.webp'), thumbnail: require('@/assets/product/36T1.webp'), id: 4 }
      ],
      features: 'Features:',
      currentFeatures: [],
      categories: [
        { id: 1, name: this.$t('categories.miniLightBars') },
        { id: 2, name: this.$t('categories.fullLightBars') },
        { id: 3, name: this.$t('categories.visorLightBars') },
        { id: 4, name: this.$t('categories.deckDashLights') },
        { id: 5, name: this.$t('categories.grilleSurfaceMounts') },
        { id: 6, name: this.$t('categories.siren') },
        { id: 7, name: this.$t('categories.trafficAdvisors') },
        { id: 8, name: this.$t('categories.mountingBrackets') },
        { id: 9, name: "OFF ROAD/WORK LIGHTS" },
        { id: 10, name: "SWITCH BOXES" }
      ],
      tuijianPdt: [
        require('@/assets/product/36T1.webp'),
        require('@/assets/product/36T1.webp'),
        require('@/assets/product/36T1.webp'),
        require('@/assets/product/36T1.webp'),
        require('@/assets/product/36T1.webp')
      ],
      imageId: 0,
      currentPid: 0,
      currentPdt: {},
      products: [],
      allFeatures: {
        "T18": [
          "SAE J845 Standard",
          "Optic Technology - TIR Optics",
          "60 total 3-watt LEDs",
          "34 total flash patterns",
          "Non-volatile memory recalls last flash pattern",
          "Lifespan of up to 100,000 hours",
          "Cig plug with On/Off switch & flash pattern toggle sold separately",
          "11' of cable from light bar to connector",
          "Weather-proof housing",
          "Includes Magnet brackets for mounting",
          "Powered by 11V-14V",
          "Max 3.4 Amp Draw"
        ],
        "L18": [
          "SAE J845 Standard",
          "Optic Technology - Linear Optics",
          "120 total 3-watt LEDs",
          "44 total flash patterns",
          "Non-volatile memory recalls last flash pattern",
          "Lifespan of up to 100,000 hours",
          "Cig plug with On/Off switch & flash pattern toggle sold separately",
          "11' of cable from light bar to connector",
          "Weather-proof housing",
          "Includes Magnet brackets for mounting",
          "Powered by 11V-14V",
          "Max 4.7 Amp Draw"
        ],
        "T27": [
          "SAE J845 Standard",
          "Optic Technology - TIR Optics",
          "84 total 3-watt LEDs",
          "34 total flash patterns",
          "Non-volatile memory recalls last flash pattern",
          "Lifespan of up to 100,000 hours",
          "Cig plug with On/Off switch & flash pattern toggle sold separately",
          "12' of cable from light bar to connector",
          "12.5' of power cable from connector",
          "12.5' of auxiliary cable from connector",
          "Weather-proof housing",
          "Includes Magnet brackets for mounting",
          "Powered by 11V-14V"
        ],
        "L27": [
          "SAE J845 Standard",
          "Optic Technology - Linear Optics",
          "168 total 3-watt LEDs",
          "44 total flash patterns",
          "Non-volatile memory recalls last flash pattern",
          "Lifespan of up to 100,000 hours",
          "Cig plug with On/Off switch & flash pattern toggle sold separately",
          "12' of cable from light bar to connector",
          "12.5' of power cable from connector",
          "12.5' of auxiliary cable from connector",
          "Weather-proof housing",
          "Includes Magnet brackets for mounting",
          "Powered by 11V-14V"
        ],
        "T36": [
          "SAE J845 Standard",
          "Optic Technology - TIR Optics",
          "108 total 3-watt LEDs",
          "34 total flash patterns",
          "Non-volatile memory recalls last flash pattern",
          "Lifespan of up to 100,000 hours",
          "Cig plug with On/Off switch & flash pattern toggle sold separately",
          "12' of cable from light bar to connector",
          "12.5' of power cable from connector",
          "12.5' of auxiliary cable from connector",
          "Weather-proof housing",
          "Includes Magnet brackets for mounting",
          "Powered by 11V-14V"
        ],
        "L36": [
          "SAE J845 Standard",
          "Optic Technology - Linear Optics",
          "216 total 3-watt LEDs",
          "44 total flash patterns",
          "Non-volatile memory recalls last flash pattern",
          "Lifespan of up to 100,000 hours",
          "Cig plug with On/Off switch & flash pattern toggle sold separately",
          "12' of cable from light bar to connector",
          "12.5' of power cable from connector",
          "12.5' of auxiliary cable from connector",
          "Weather-proof housing",
          "Includes Magnet brackets for mounting",
          "Powered by 11V-14V"
        ],
        "T47": [
          "SAE J845 Standard",
          "Optic Technology - TIR Optics",
          "132 total 3-watt LEDs",
          "34 total flash patterns",
          "Non-volatile memory recalls last flash pattern",
          "Lifespan of up to 100,000 hours",
          "Cig plug with On/Off switch & flash pattern toggle sold separately",
          "12' of cable from light bar to connector",
          "12.5' of power cable from connector",
          "12.5' of auxiliary cable from connector",
          "Weather-proof housing",
          "Includes Magnet brackets for mounting",
          "Powered by 11V-14V"
        ],
        "L47": [
          "SAE J845 Standard",
          "Optic Technology - Linear Optics",
          "264 total 3-watt LEDs",
          "44 total flash patterns",
          "Non-volatile memory recalls last flash pattern",
          "Lifespan of up to 100,000 hours",
          "Cig plug with On/Off switch & flash pattern toggle sold separately",
          "12' of cable from light bar to connector",
          "12.5' of power cable from connector",
          "12.5' of auxiliary cable from connector",
          "Weather-proof housing",
          "Includes Magnet brackets for mounting",
          "Powered by 11V-14V"
        ],
        "T55": [
          "SAE J845 Standard",
          "Optic Technology - TIR Optics",
          "156 total 3-watt LEDs",
          "34 total flash patterns",
          "Non-volatile memory recalls last flash pattern",
          "Lifespan of up to 100,000 hours",
          "Cig plug with On/Off switch & flash pattern toggle sold separately",
          "12' of cable from light bar to connector",
          "12.5' of power cable from connector",
          "12.5' of auxiliary cable from connector",
          "Weather-proof housing",
          "Includes Magnet brackets for mounting",
          "Powered by 11V-14V"
        ],
        "L55": [
          "SAE J845 Standard",
          "Optic Technology - Linear Optics",
          "312 total 3-watt LEDs",
          "44 total flash patterns",
          "Non-volatile memory recalls last flash pattern",
          "Lifespan of up to 100,000 hours",
          "Cig plug with On/Off switch & flash pattern toggle sold separately",
          "12' of cable from light bar to connector",
          "12.5' of power cable from connector",
          "12.5' of auxiliary cable from connector",
          "Weather-proof housing",
          "Includes Magnet brackets for mounting",
          "Powered by 11V-14V"
        ],
        "T63": [
          "SAE J845 Standard",
          "Optic Technology - TIR Optics",
          "180 total 3-watt LEDs",
          "34 total flash patterns",
          "Non-volatile memory recalls last flash pattern",
          "Lifespan of up to 100,000 hours",
          "Cig plug with On/Off switch & flash pattern toggle sold separately",
          "12' of cable from light bar to connector",
          "12.5' of power cable from connector",
          "12.5' of auxiliary cable from connector",
          "Weather-proof housing",
          "Includes Magnet brackets for mounting",
          "Powered by 11V-14V"
        ],
        "L63": [
          "SAE J845 Standard",
          "Optic Technology - Linear Optics",
          "360 total 3-watt LEDs",
          "44 total flash patterns",
          "Non-volatile memory recalls last flash pattern",
          "Lifespan of up to 100,000 hours",
          "Cig plug with On/Off switch & flash pattern toggle sold separately",
          "12' of cable from light bar to connector",
          "12.5' of power cable from connector",
          "12.5' of auxiliary cable from connector",
          "Weather-proof housing",
          "Includes Magnet brackets for mounting",
          "Powered by 11V-14V"
        ],
        "T71": [
          "SAE J845 Standard",
          "Optic Technology - TIR Optics",
          "204 total 3-watt LEDs",
          "34 total flash patterns",
          "Non-volatile memory recalls last flash pattern",
          "Lifespan of up to 100,000 hours",
          "Cig plug with On/Off switch & flash pattern toggle sold separately",
          "12' of cable from light bar to connector",
          "12.5' of power cable from connector",
          "12.5' of auxiliary cable from connector",
          "Weather-proof housing",
          "Includes Magnet brackets for mounting",
          "Powered by 11V-14V"
        ],
        "L71": [
          "SAE J845 Standard",
          "Optic Technology - Linear Optics",
          "408 total 3-watt LEDs",
          "44 total flash patterns",
          "Non-volatile memory recalls last flash pattern",
          "Lifespan of up to 100,000 hours",
          "Cig plug with On/Off switch & flash pattern toggle sold separately",
          "12' of cable from light bar to connector",
          "12.5' of power cable from connector",
          "12.5' of auxiliary cable from connector",
          "Weather-proof housing",
          "Includes Magnet brackets for mounting",
          "Powered by 11V-14V"
        ],
        "GD1": [
          "SAE J845 Standard",
          "Optic Technology - TIR Optics",
          "40 total 3-watt LEDs",
          "30 total flash patterns",
          "Non-volatile memory recalls last flash pattern",
          "Lifespan of up to 100,000 hours",
          "Cig plug with On/Off switch & flash pattern toggle sold separately",
          "11' of cable from light bar to connector",
          "Weather-proof housing",
          "Includes Magnet brackets for mounting",
          "Powered by 11V-14V",
          "Max 3.4 Amp Draw"
        ],
        "GD2": [
          "SAE J845 Standard",
          "Optic Technology - TIR Optics",
          "40 total 3-watt LEDs",
          "30 total flash patterns",
          "Non-volatile memory recalls last flash pattern",
          "Lifespan of up to 100,000 hours",
          "Cig plug with On/Off switch & flash pattern toggle sold separately",
          "11' of cable from light bar to connector",
          "Weather-proof housing",
          "Includes Magnet brackets for mounting",
          "Powered by 11V-14V",
          "Max 3.4 Amp Draw"
        ],
        "GD4": [
          "SAE J845 Standard",
          "Optic Technology - TIR Optics",
          "40 total 3-watt LEDs",
          "30 total flash patterns",
          "Non-volatile memory recalls last flash pattern",
          "Lifespan of up to 100,000 hours",
          "Cig plug with On/Off switch & flash pattern toggle sold separately",
          "11' of cable from light bar to connector",
          "Weather-proof housing",
          "Includes Magnet brackets for mounting",
          "Powered by 11V-14V",
          "Max 3.4 Amp Draw"
        ],
        "GD6": [
          "SAE J845 Standard",
          "Optic Technology - TIR Optics",
          "40 total 3-watt LEDs",
          "30 total flash patterns",
          "Non-volatile memory recalls last flash pattern",
          "Lifespan of up to 100,000 hours",
          "Cig plug with On/Off switch & flash pattern toggle sold separately",
          "11' of cable from light bar to connector",
          "Weather-proof housing",
          "Includes Magnet brackets for mounting",
          "Powered by 11V-14V",
          "Max 3.4 Amp Draw"
        ],
        "GD8": [
          "SAE J845 Standard",
          "Optic Technology - TIR Optics",
          "40 total 3-watt LEDs",
          "30 total flash patterns",
          "Non-volatile memory recalls last flash pattern",
          "Lifespan of up to 100,000 hours",
          "Cig plug with On/Off switch & flash pattern toggle sold separately",
          "11' of cable from light bar to connector",
          "Weather-proof housing",
          "Includes Magnet brackets for mounting",
          "Powered by 11V-14V",
          "Max 3.4 Amp Draw"
        ],
        "ZT3": [
          "SAE J845 Standard",
          "Optic Technology - TIR Optics",
          "40 total 3-watt LEDs",
          "30 total flash patterns",
          "Non-volatile memory recalls last flash pattern",
          "Lifespan of up to 100,000 hours",
          "Cig plug with On/Off switch & flash pattern toggle sold separately",
          "11' of cable from light bar to connector",
          "Weather-proof housing",
          "Includes Magnet brackets for mounting",
          "Powered by 11V-14V",
          "Max 3.4 Amp Draw"
        ],
        "ZT4": [
          "SAE J845 Standard",
          "Optic Technology - TIR Optics",
          "40 total 3-watt LEDs",
          "30 total flash patterns",
          "Non-volatile memory recalls last flash pattern",
          "Lifespan of up to 100,000 hours",
          "Cig plug with On/Off switch & flash pattern toggle sold separately",
          "11' of cable from light bar to connector",
          "Weather-proof housing",
          "Includes Magnet brackets for mounting",
          "Powered by 11V-14V",
          "Max 3.4 Amp Draw"
        ],
        "ZT6": [
          "SAE J845 Standard",
          "Optic Technology - TIR Optics",
          "40 total 3-watt LEDs",
          "30 total flash patterns",
          "Non-volatile memory recalls last flash pattern",
          "Lifespan of up to 100,000 hours",
          "Cig plug with On/Off switch & flash pattern toggle sold separately",
          "11' of cable from light bar to connector",
          "Weather-proof housing",
          "Includes Magnet brackets for mounting",
          "Powered by 11V-14V",
          "Max 3.4 Amp Draw"
        ],
        "ZL3": [
          "SAE J845 Standard",
          "Optic Technology - TIR Optics",
          "3 LED 3-watt LEDs",
          "Built in sync and alternate sync functionality",
          "24 available individual flash patterns",
          "3 alternate sync pattern speeds",
          "Non-volatile memory recalls last flash patterns",
          "Lifespan of up to 100,000 hours",
          "Includes 1 foot of cable",
          "Weather-proof housing",
          "Powered by 11V-14V",
          "Max 290 mAh Draw"
        ],
        "ZL4": [
          "SAE J845 Standard",
          "Optic Technology - TIR Optics",
          "4 LED 3-watt LEDs",
          "Built in sync and alternate sync functionality",
          "34 available individual flash patterns",
          "3 alternate sync pattern speeds",
          "Non-volatile memory recalls last flash patterns",
          "Lifespan of up to 100,000 hours",
          "Includes 1 foot of cable",
          "Weather-proof housing",
          "Powered by 11V-14V",
          "Max 570 mAh Draw"
        ],
        "ZL6": [
          "SAE J845 Standard",
          "Optic Technology - TIR Optics",
          "6 LED 3-watt LEDs",
          "Built in sync and alternate sync functionality",
          "34 available individual flash patterns",
          "3 alternate sync pattern speeds",
          "Non-volatile memory recalls last flash patterns",
          "Lifespan of up to 100,000 hours",
          "Includes 1 foot of cable",
          "Weather-proof housing",
          "Powered by 11V-14V",
          "Max 570 mAh Draw"
        ]
      },
      zlMode: {
        "cd": "2021302369929",
        "xdt": "2024306644134",
        "xdl": "2024306644172",
        "gd": "2024306644064",
        "lvgai": "2020305401353"
      },
      currentZL: "",
      // 新增产品详情数据
      productDescription: '',
      techSpecs: [],
      applicationScenarios: [],
      T18DES: "The SY-001 18 TIR LED Light Bar packed with 120 pcs 3-Watt LEDs, this 18 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 34 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements.\n",
      T27DES: "The SY-001 27 TIR LED Light Bar packed with 168 pcs 3-Watt LEDs, this 27 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 34 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements.\n",
      T36DES: "The SY-001 36 TIR LED Light Bar packed with 216 pcs 3-Watt LEDs, this 36 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 34 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements\n",
      T47DES: "The SY-001 47 TIR LED Light Bar packed with 264 pcs 3-Watt LEDs, this 47 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 34 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements.\n",
      T55DES: "The SY-001 55 TIR LED Light Bar packed with 312 pcs 3-Watt LEDs, this 55 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 34 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements.\n",
      T63DES: "The SY-001 63 TIR LED Light Bar packed with 360 pcs 3-Watt LEDs, this 18 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 34 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements.\n",
      T71DES: "The SY-001 71 TIR LED Light Bar packed with 408 pcs 3-Watt LEDs, this 18 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 34 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements.\n",
      L18DES: "The SY-001 18 Linear LED Light Bar packed with 120 pcs 3-Watt LEDs, this 18 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 44 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements\n",
      L27DES: "The SY-001 27 Linear LED Light Bar packed with 168 pcs 3-Watt LEDs, this 18 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 44flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements\n",
      L36DES: "The SY-001 36 Linear LED Light Bar packed with 216 pcs 3-Watt LEDs, this 18 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 44 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements\n",
      L47DES: "The SY-001 47 Linear LED Light Bar packed with 264 pcs 3-Watt LEDs, this 18 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 44 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements\n",
      L55DES: "The SY-001 55 Linear LED Light Bar packed with 312 pcs 3-Watt LEDs, this 18 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 44 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements\n",
      L63DES: "The SY-001 63 Linear LED Light Bar packed with 360 pcs 3-Watt LEDs, this 18 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 44 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements\n",
      L71DES: "The SY-001 71 Linear LED Light Bar packed with 408 pcs 3-Watt LEDs, this 18 emergency light bar combines innovative LED technology and a polycarbonate, anodized aluminum hybrid housing into one impressive unit. In the emergency lighting business, reliability is key. That’s why we work day after day to build trust through SAE J845 Certification, 2 year Warranties and providing the highest quality, most affordable products on the market. IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance. With a 6 LED amber arrow stick (upgradable to multicolor), non-volatile memory recall to lock in your favorite of 44 flash patterns, and your choice of a universal or vehicle specific gutter mount brackets Ready to be customized to meet your special requirements\n",
      TGD: "Tough, anti-corrosive and water-resistant aluminum housing provides excellent heat dissipation\n" +
          "Available in dual or triple colors\n" +
          "Flexible in lengths, suitable for different vehicles for interior or exterior use\n" +
          "Easy installation with screw or bracket mount\n" +
          "Ready to be customized to meet your special requirements.",
      TZD: "Every unit comes in your choice of Red, Blue, Clear, Green, or Amber and with a variety of unique flash patterns. Features warning and working light functions Aluminum materials with spray coating• PC lens, UV resistant Two types of flexible brackets suitable for installation on car grilles, bumpers, and hoods IP 68 rated; fully encapsulated for moisture, vibration and corrosion resistance.\n",
      ZJ: "Mounting brackets provide the necessary support to securely install emergency warning lights to your vehicle. Choose from our generic and vehicle specific mounting brackets below to make installation of your products quick and easy.",
      ZYB: "One of the most sought-after warning light solutions is the interior LED visor light bar. With diverse configurations and versatile functions, these lights are ideal for multiple vehicle lighting needs. Whether you need undercover or low-profile illumination for your vehicle, our interior windshield visor lights deliver the perfect solution.\n" +
          "Featuring high-performance 3-watt LED technology encased in a compact, streamlined design, our budget-friendly range of LED visor light bars promises to surpass your expectations. Each unit combines powerful brightness with discreet aesthetics, making it an essential addition for safety, visibility, or specialized vehicle setups.",
      currentDes: "",
      JBQ: "In the realm of emergency response, sirens act as a non-negotiable asset for first responders and emergency vehicles. A loud, high-output siren is critical to asserting road dominance when time and safety are of the essence.",
      // 新增配件数据
      accessories: [
        {
          id: 1,
          name: "Magnet Mounting Brackets",
          description: "Easy-to-install magnet brackets for quick mounting on vehicle roofs or other metal surfaces.",
          image: require('@/assets/product/PJ/QADHB1.webp'),
          productIds: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] // 适用产品ID
        },
        {
          id: 2,
          name: "Cigarette Lighter Plug",
          description: "Convenient power plug with on/off switch and flash pattern toggle for easy operation.",
          image: require('@/assets/product/touming/JBQ/A11.webp'),
          productIds: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
        },
        {
          id: 3,
          name: "Universal Gutter Mounts",
          description: "Adjustable gutter mounts suitable for various vehicle types, providing secure installation.",
          image: require('@/assets/product/touming/JBQ/A11.webp'),
          productIds: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
        },
        {
          id: 4,
          name: "Arrow Stick Upgrade",
          description: "6-LED amber arrow stick that can be upgraded to multicolor for enhanced signaling capabilities.",
          image: require('@/assets/product/touming/JBQ/A11.webp'),
          productIds: [0, 1, 2, 3, 4, 5, 6]
        },
        {
          id: 5,
          name: "Surface Mounting Kit",
          description: "Complete kit for surface mounting on grilles, bumpers, or other vehicle surfaces.",
          image: require('@/assets/product/touming/JBQ/A11.webp'),
          productIds: [12, 13, 14, 15, 16, 17]
        },
        {
          id: 6,
          name: "Weatherproof Cover",
          description: "Protective cover to shield the light bar from harsh weather conditions and debris.",
          image: require('@/assets/product/touming/JBQ/A11.webp'),
          productIds: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17]
        }
      ],
      currentAccessories: [],
      currentVideoUrl: require('@/assets/video/27.mp4'),
      videoList: [
        {
          id: 1,
          url: require('@/assets/video/27.mp4'),
          title: "Product Overview",
          description: "Complete demonstration of all features and functions"
        }
      ]
    };
  },
  mounted() {
    // 初始化产品列表
    this.initializeProducts();
    // 获取路由参数中的产品ID（默认0）
    const productId = Number(this.$route.query.pid) || 0;
    // 查找当前产品
    this.currentPdt = this.findProductById(this.products, productId) || this.products[0];
    // 初始化图片列表
    this.initImageList();
    // 初始化产品详情数据
    this.initProductDetailData();
    // 初始化配件数据
    this.initAccessories();
    // 更新页面标题（根据产品类别）
    this.updatePageTitle();
  },
  watch: {
    // 监听当前产品变化，重新初始化数据
    currentPdt: {
      deep: true,
      handler() {
        this.initImageList();
        this.initProductDetailData();
        this.initAccessories();
        this.updatePageTitle();
      }
    }
  },
  methods: {
    getCategories() {
      return [
        { id: 1, name: this.$t('categories.miniLightBars') },
        { id: 2, name: this.$t('categories.fullLightBars') },
        { id: 3, name: this.$t('categories.visorLightBars') },
        { id: 4, name: this.$t('categories.deckDashLights') },
        { id: 5, name: this.$t('categories.grilleSurfaceMounts') },
        { id: 6, name: this.$t('categories.siren') },
        { id: 7, name: this.$t('categories.trafficAdvisors') },
        { id: 8, name: this.$t('categories.mountingBrackets') },
        { id: 9, name: "OFF ROAD/WORK LIGHTS" },
        { id: 10, name: "SWITCH BOXES" }
      ];
    },
    qiehuanImage(imageId) {
      this.imageId = imageId;
      // 特殊产品的图片切换逻辑（格栅灯、遮阳板灯等）
    /*  if (this.currentPdt.id >= 12 && this.currentPdt.id <= 17 || this.currentPdt.id > 22) {
        this.imageId = imageId;
      } else {
        // 传统长条灯的图片切换逻辑（反转0和1）
        this.imageId = imageId === 0 ? 1 : (imageId === 1 ? 0 : imageId);
      }*/
    },
    createProduct(id, name, size, categoryId, imagesDir, seriesId, type, seriesName) {
      return {
        id: id,
        categoryId,
        seriesId,
        name: `${seriesName} ${size}" ${name}`,
        defaultImage: require(`@/assets/product/touming/${type}/${imagesDir}7.webp`),
        hoverImage: require(`@/assets/product/touming/${type}/${imagesDir}6.webp`),
        isHovered: false,
        imageList: [0, 1, 2, 3, 4].map((i) => ({
          src: require(`@/assets/product/touming/${type}/${imagesDir}${i + 1}.webp`),
          thumbnail: require(`@/assets/product/touming/${type}/${imagesDir}${i + 1}.webp`),
          id: i
        }))
      };
    },
    createProductGLight(id, name, size, categoryId, imagesDir, seriesId, type, seriesName) {
      console.log(seriesName)
      return {
        id: id,
        categoryId,
        seriesId,
        name: name,
        defaultImage: require(`@/assets/product/${type}/${imagesDir}4.webp`),
        hoverImage: require(`@/assets/product/${type}/${imagesDir}5.webp`),
        isHovered: false,
        imageList: [0, 1, 2, 3, 4].map((i) => ({
          src: require(`@/assets/product/touming/${type}/${imagesDir}${i + 1}.webp`),
          thumbnail: require(`@/assets/product/touming/${type}/${imagesDir}${i + 1}.webp`),
          id: i
        }))
      };
    },
    createProductGDLight(id, name, size, categoryId, imagesDir, seriesId, type, seriesName) {
      console.log(seriesName)
      return {
        id: id,
        categoryId,
        seriesId,
        name: name,
        defaultImage: require(`@/assets/product/${type}/${imagesDir}4.webp`),
        hoverImage: require(`@/assets/product/${type}/${imagesDir}5.webp`),
        isHovered: false,
        imageList: [0, 1, 2, 3, 4].map((i) => ({
          src: require(`@/assets/product/touming/${type}/${imagesDir}${i + 1}.webp`),
          thumbnail: require(`@/assets/product/touming/${type}/${imagesDir}${i + 1}.webp`),
          id: i
        }))
      };
    },
    createProductJBQLight(id, name, size, categoryId, imagesDir, seriesId, type, seriesName) {
      console.log(seriesName)
      return {
        id: id,
        categoryId,
        seriesId,
        name: name,
        defaultImage: require(`@/assets/product/touming/${type}/${imagesDir}4.webp`),
        hoverImage: require(`@/assets/product/touming/${type}/${imagesDir}5.webp`),
        isHovered: false,
        imageList: [0, 1, 2, 3, 4].map((i) => ({
          src: require(`@/assets/product/touming/${type}/${imagesDir}${i + 1}.webp`),
          thumbnail: require(`@/assets/product/touming/${type}/${imagesDir}${i + 1}.webp`),
          id: i
        }))
      };
    },
    createProductZYBLight(id, name, size, categoryId, imagesDir, seriesId, type, seriesName) {
      console.log(seriesName)
      return {
        id: id,
        categoryId,
        seriesId,
        name: name,
        defaultImage: require(`@/assets/product/${type}/${imagesDir}1.webp`),
        hoverImage: require(`@/assets/product/${type}/${imagesDir}4.webp`),
        isHovered: false,
        imageList: [0, 1, 2, 3, 4].map((i) => ({
          src: require(`@/assets/product/touming/${type}/${imagesDir}${i + 1}.webp`),
          thumbnail: require(`@/assets/product/touming/${type}/${imagesDir}${i + 1}.webp`),
          id: i
        }))
      };
    },
    findProductById(products, id) {
      // 先校验id有效性（必须是数字）
      if (typeof id !== "number" || isNaN(id)) {
        console.warn("无效的产品ID:", id);
        return null;
      }
      // 严格匹配ID（===），避免类型转换导致的错误
      const product = products.find(item => item.id === id);
      if (!product) {
        console.warn(`未找到ID为${id}的产品`);
        return null;
      }
      return product;
    },
    createProductZJ(id, name, size, categoryId, imagesDir, seriesId, type, seriesName) {
      console.log(seriesName)
      return {
        id: id,
        categoryId,
        seriesId,
        name: name,
        defaultImage: require(`@/assets/product/${type}/${imagesDir}1.webp`),
        hoverImage: require(`@/assets/product/${type}/${imagesDir}2.webp`),
        isHovered: false,
        imageList: [0, 1, 2, 3].map((i) => ({
          src: require(`@/assets/product/${type}/${imagesDir}${i + 1}.webp`),
          thumbnail: require(`@/assets/product/${type}/${imagesDir}${i + 1}.webp`),
          id: i
        }))
      };
    },
    createProductZJ2(id, name, size, categoryId, imagesDir, seriesId, type, seriesName) {
      console.log(seriesName)
      return {
        id: id,
        categoryId,
        seriesId,
        name: name,
        defaultImage: require(`@/assets/product/${type}/${imagesDir}5.webp`),
        hoverImage: require(`@/assets/product/${type}/${imagesDir}4.webp`),
        isHovered: false,
        imageList: [0, 1, 2, 3, 4].map((i) => ({
          src: require(`@/assets/product/${type}/${imagesDir}${i + 1}.webp`),
          thumbnail: require(`@/assets/product/${type}/${imagesDir}${i + 1}.webp`),
          id: i
        }))
      };
    },
    // 初始化产品数据
    initializeProducts() {
      this.products = [
        this.createProduct(0, this.$t("mini"), 18, 1, "18T", 1, "T", "SY-001 TIR"),
        this.createProduct(1, this.$t("mini"), 27, 1, "27T", 1, "T", "SY-001 TIR"),
        this.createProduct(2, this.$t("full"), 36, 2, "36T", 1, "T", "SY-001 TIR"),
        this.createProduct(3, this.$t("full"), 47, 2, "47T", 1, "T", "SY-001 TIR"),
        this.createProduct(4, this.$t("full"), 55, 2, "55T", 1, "T", "SY-001 TIR"),
        this.createProduct(5, this.$t("full"), 63, 2, "63T", 1, "T", "SY-001 TIR"),
        this.createProduct(6, this.$t("full"), 71, 2, "71T", 1, "T", "SY-001 TIR"),
        this.createProduct(7, this.$t("mini"), 18, 1, "18L", 2, "L", "SY-001 Linear"),
        this.createProduct(8, this.$t("mini"), 27, 1, "27L", 2, "L", "SY-001 Linear"),
        this.createProduct(9, this.$t("full"), 36, 2, "36L", 2, "L", "SY-001 Linear"),
        this.createProduct(10, this.$t("full"), 47, 2, "47L", 2, "L", "SY-001 Linear"),
        this.createProduct(11, this.$t("full"), 55, 2, "55L", 2, "L", "SY-001 Linear"),

        this.createProductGLight(12, this.$t("productNames.g003LinearGrilleLight"), 3, 5, "Z3L", 2, "L", "Linear"),
        this.createProductGLight(13, this.$t("productNames.g004LinearGrilleLight"), 4, 5, "Z4L", 2, "L", "Linear"),
        this.createProductGLight(14, this.$t("productNames.g006LinearGrilleLight"), 6, 5, "Z6L", 2, "L", "Linear"),
        this.createProductGLight(15, this.$t("productNames.g003TirGrilleLight"), 3, 5, "Z3T", 1, "T", "TIR"),
        this.createProductGLight(16, this.$t("productNames.g004TirGrilleLight"), 4, 5, "Z4T", 1, "T", "TIR"),
        this.createProductGLight(17, this.$t("productNames.g006TirGrilleLight"), 6, 5, "Z6T", 1, "T", "TIR"),

        this.createProductGDLight(18, "HB-STT1", 1, 4, "G1", 1, "T", "TIR"),
        this.createProductGDLight(19, "HB-STT2", 2, 4, "G2", 1, "T", "TIR"),
        this.createProductGDLight(20, "HB-STT4", 4, 4, "G4", 1, "T", "TIR"),
        this.createProductGDLight(21, "HB-STT6", 6, 7, "G6", 1, "T", "TIR"),
        this.createProductGDLight(22, "HB-STT8", 8, 7, "G8", 1, "T", "TIR"),

        this.createProduct(23, this.$t("full"), 36, 2, "Y236T", 1, "T", "SY-002 TIR"),
        this.createProduct(24, this.$t("full"), 47, 2, "Y247T", 1, "T", "SY-002 TIR"),

        this.createProductZYBLight(25, this.$t("productNames.syRt8VisorLightBar"), 4, 3, "ZY4", 1, "T", "TIR"),
        this.createProductZYBLight(26, this.$t("productNames.syRt10VisorLightBar"), 5, 3, "ZY5", 1, "T", "TIR"),

        this.createProductJBQLight(27, "HS-A150", 5, 3, "A1", 1, "JBQ", "TIR"),
        this.createProductJBQLight(28, "HS-B200", 5, 3, "B2", 1, "JBQ", "TIR"),
        this.createProductJBQLight(29, "HS-M100", 5, 3, "M1", 1, "JBQ", "TIR"),
        this.createProductJBQLight(30, "HP-A100", 5, 3, "PA1", 1, "JBQ", "TIR"),
        this.createProductJBQLight(31, "HS-V100", 5, 3, "V1", 1, "JBQ", "TIR"),

        this.createProductZJ(32, "HQ-ADHB", 5, 8, "QADHB", 5, "PJ", "HQ-122"),
        this.createProductZJ(33, "HQ-DSTVB", 5, 8, "QDSTVB", 5, "PJ", "HQ-111"),
        this.createProductZJ(34, "HQ-HMB", 5, 8, "QHMB", 5, "PJ", "Q-HMB"),
        this.createProductZJ(35, "HQ-110", 5, 8, "QSSTB", 5, "PJ", "HQ-110"),
        this.createProductZJ(36, "HQ-STHB", 5, 8, "QSTHB", 5, "PJ", "HQ-120"),

        this.createProductZJ2(37, "HQ-LPB", 5, 8, "QLPB", 5, "PJ", "Q-LPB"),
        this.createProductZJ2(38, "HQ-RVE", 5, 8, "QRVE", 5, "PJ", "Q-RVE")
      ];
    },
    getCategoryNameById(id) {
      const categories = this.getCategories();
      const category = categories.find(item => item.id === id);
      return category ? category.name : '未知类别';
    },
    // 初始化图片列表
    initImageList() {
      this.imageList = [];
      if (!this.currentPdt || !this.currentPdt.imageList) return;

      if (this.currentPdt.id >= 12 && this.currentPdt.id <= 17 || this.currentPdt.id > 22) {
        // 格栅灯、遮阳板灯等产品：直接使用自带图片列表，默认显示第一张
        this.imageList = [...this.currentPdt.imageList];
        this.imageId = 0;
      } else {
        // 传统长条灯：沿用原有图片列表，默认显示第二张
        this.imageList = [...this.currentPdt.imageList];
        this.imageId = 1;
      }
    },
    // 初始化产品详情数据（描述、技术参数、应用场景、专利号）
    initProductDetailData() {
      if (!this.currentPdt) return;

      const pdtName = this.currentPdt.name || "";

      // 1. 产品描述
      if (pdtName.includes("TIR 18")) this.productDescription = this.T18DES;
      else if (pdtName.includes("TIR 27")) this.productDescription = this.T27DES;
      else if (pdtName.includes("TIR 36")) this.productDescription = this.T36DES;
      else if (pdtName.includes("TIR 47")) this.productDescription = this.T47DES;
      else if (pdtName.includes("TIR 55")) this.productDescription = this.T55DES;
      else if (pdtName.includes("TIR 63")) this.productDescription = this.T63DES;
      else if (pdtName.includes("TIR 71")) this.productDescription = this.T71DES;
      else if (pdtName.includes("Linear 18")) this.productDescription = this.L18DES;
      else if (pdtName.includes("Linear 27")) this.productDescription = this.L27DES;
      else if (pdtName.includes("Linear 36")) this.productDescription = this.L36DES;
      else if (pdtName.includes("Linear 47")) this.productDescription = this.L47DES;
      else if (pdtName.includes("Linear 55")) this.productDescription = this.L55DES;
      else if (pdtName.includes("Grille")) this.productDescription = this.TZD;
      else if (pdtName.includes("Visor")) this.productDescription = this.ZYB;
      else if (pdtName.includes("HB-STT")) this.productDescription = this.TGD;
      else if (pdtName.includes("HQ-")) this.productDescription = this.ZJ;
      else if (pdtName.includes("HS-") || pdtName.includes("HP-")) this.productDescription = this.JBQ;
      else this.productDescription = this.T18DES;

      // 2. 产品特性（用于技术参数提取）
      const featureKey = pdtName.includes("TIR 18") ? "T18"
          : pdtName.includes("TIR 27") ? "T27"
              : pdtName.includes("TIR 36") ? "T36"
                  : pdtName.includes("TIR 47") ? "T47"
                      : pdtName.includes("TIR 55") ? "T55"
                          : pdtName.includes("TIR 63") ? "T63"
                              : pdtName.includes("TIR 71") ? "T71"
                                  : pdtName.includes("Linear 18") ? "L18"
                                      : pdtName.includes("Linear 27") ? "L27"
                                          : pdtName.includes("Linear 36") ? "L36"
                                              : pdtName.includes("Linear 47") ? "L47"
                                                  : pdtName.includes("Linear 55") ? "L55"
                                                      : pdtName.includes("Z3L") ? "ZL3"
                                                          : pdtName.includes("Z4L") ? "ZL4"
                                                              : pdtName.includes("Z6L") ? "ZL6"
                                                                  : pdtName.includes("Z3T") ? "ZT3"
                                                                      : pdtName.includes("Z4T") ? "ZT4"
                                                                          : pdtName.includes("Z6T") ? "ZT6"
                                                                              : pdtName.includes("HB-STT1") ? "GD1"
                                                                                  : pdtName.includes("HB-STT2") ? "GD2"
                                                                                      : pdtName.includes("HB-STT4") ? "GD4"
                                                                                          : pdtName.includes("HB-STT6") ? "GD6"
                                                                                              : pdtName.includes("HB-STT8") ? "GD8"
                                                                                                  : "";
      this.currentFeatures = this.allFeatures[featureKey] || [];

      // 3. 技术参数表格
      const ledQuantity = this.currentFeatures.find(item => item.includes("total 3-watt LEDs"))?.match(/\d+/)?.[0] || "N/A";
      const flashPatterns = this.currentFeatures.find(item => item.includes("total flash patterns"))?.match(/\d+/)?.[0] || "N/A";
      const ampDraw = this.currentFeatures.find(item => item.includes("Amp Draw"))?.split("Max ")[1] || "N/A";
      const cableLength = this.currentFeatures.find(item => item.includes("of cable")) || "N/A";

      this.techSpecs = [
        { name: this.$t('parameters.productModel'), value: pdtName },
        { name: this.$t('parameters.ledType'), value: pdtName.includes("TIR") ? "TIR Optics" : "Linear Optics" },
        { name: this.$t('parameters.ledQuantity'), value: ledQuantity },
        { name: this.$t('parameters.flashPatterns'), value: flashPatterns },
        { name: this.$t('parameters.voltage'), value: "11V-14V" },
        { name: this.$t('parameters.powerConsumption'), value: ampDraw },
        { name: this.$t('parameters.waterproofRating'), value: "IP68" },
        { name: this.$t('parameters.lifespan'), value: "Up to 100,000 hours" },
        { name: this.$t('parameters.certification'), value: "SAE J845 Standard" },
        { name: this.$t('parameters.cableLength'), value: cableLength }
      ];

      // 4. 应用场景
      this.applicationScenarios = [
        this.$t('scenarios.emergencyVehicles'),
        this.$t('scenarios.policeCars'),
        this.$t('scenarios.fireTrucks'),
        this.$t('scenarios.ambulances'),
        this.$t('scenarios.constructionVehicles'),
        this.$t('scenarios.towTrucks'),
        this.$t('scenarios.securityVehicles')
      ];

      // 5. 专利号
      if (pdtName.includes("Grille") || pdtName.includes("HB-STT")) this.currentZL = this.zlMode.gd;
      else if (pdtName.includes("Visor")) this.currentZL = this.zlMode.xdl;
      else if (pdtName.includes("Linear") && !pdtName.includes("Grille")) this.currentZL = this.zlMode.xdt;
      else this.currentZL = this.zlMode.cd;
    },
    // 初始化配件数据（根据当前产品ID筛选）
    initAccessories() {
      if (!this.currentPdt) {
        this.currentAccessories = [];
        return;
      }
      this.currentAccessories = this.accessories.filter(accessory =>
          accessory.productIds.includes(this.currentPdt.id)
      );
    },
    // 更新页面标题（根据产品类别）
    updatePageTitle() {
      if (!this.currentPdt) return;
      const categoryName = this.getCategoryNameById(this.currentPdt.categoryId);
      this.pageTitle = categoryName.toUpperCase();
    },
    // 跳转到询盘页面
    goInquire() {
      // 可携带产品ID跳转，便于询盘页面获取产品信息
      router.push({
        path: '/inquire',
        query: { productId: this.currentPdt.id, productName: this.currentPdt.name }
      });
    }
  }
};
</script>

<style scoped>
/* 全局容器样式 */
.product-list-body {
  max-width: 1480px;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Arial', sans-serif;
  color: #333;
}

/* 面包屑导航样式 */
.product-page-title-body {
  margin-bottom: 20px;
}

.product-page-title h5 {
  color: #666;
  font-weight: normal;
  font-size: 14px;
  margin: 0;
}

/* 产品标题样式 */
.list-title {
  margin: 20px 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.list-title h3 {
  color: #222;
  margin: 0 0 5px 0;
  font-size: 24px;
}

.list-title h6 {
  color: #666;
  font-weight: normal;
  font-size: 14px;
  margin: 0;
}

/* 图片和视频区域样式 */
.pdt-image-body {
  display: flex;
  gap: 30px;
  margin: 30px 0;
  flex-wrap: wrap;
}

.body-left {
  flex: 1;
  min-width: 300px;
}

.body-right {
  flex: 1;
  min-width: 250px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

/* 大图展示区（核心修改：小屏幕增大高度） */
.pdt-image-show {
  width: 100%;
  height: 400px;
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 15px;
}

.pdt-image-show img {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 保持图片比例，完整显示 */
  transition: all 0.3s ease;
  padding: 10px; /* 增加内边距，避免图片贴边 */
}

/* 小图列表样式（保持五等分） */
.pdt-image-mini {
  display: flex;
  gap: 5px;
  overflow-x: auto;
  padding: 0 0 10px 0;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
}

.pdt-image-mini .xiaotu {
  width: calc(20% - 8px);
  flex-shrink: 0;
  aspect-ratio: 1/1;
  border: 2px solid transparent;
  border-radius: 4px;
  object-fit: contain;
  cursor: pointer;
  transition: all 0.2s ease;
}

.pdt-image-mini .xiaotu:hover,
.pdt-image-mini .xiaotu.active {
  border-color: #1890ff;
}

/* 视频容器样式 */
.video-container {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.product-video {
  width: 100%;
  height: 505px;
  object-fit: cover;
  background-color: #000;
}

/* 产品详情区域样式 */
.product-detail-section {
  margin: 50px 0;
  padding: 30px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.detail-title {
  margin-bottom: 25px;
  padding-bottom: 10px;
  border-bottom: 2px solid #1890ff;
}

.detail-title h3 {
  color: #222;
  font-size: 20px;
  margin: 0;
}

.detail-content {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.basic-info, .technical-specs, .application-scenarios {
  background-color: #fff;
  padding: 20px;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.basic-info h4, .technical-specs h4, .application-scenarios h4 {
  color: #1890ff;
  font-size: 16px;
  margin: 0 0 15px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #eee;
}

.basic-info p {
  line-height: 1.8;
  color: #666;
  margin: 0;
  font-size: 14px;
}

/* 技术参数表格样式 */
.technical-specs table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.technical-specs th, .technical-specs td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.technical-specs th {
  background-color: #f5f5f5;
  color: #333;
  font-weight: 600;
}

.technical-specs td {
  color: #666;
}

.technical-specs tr:hover td {
  background-color: #fafafa;
}

/* 应用场景样式 */
.application-scenarios ul {
  margin: 0;
  padding-left: 20px;
}

.application-scenarios li {
  line-height: 2;
  color: #666;
  font-size: 14px;
  list-style-type: disc;
}

/* 产品配件区域样式（五等分） */
.product-accessories-section {
  margin: 30px 0 50px;
  padding: 30px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.accessories-content {
  margin-top: 20px;
}

.accessory-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 15px;
  align-items: stretch;
}

.accessory-item {
  background-color: #fff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
}

.accessory-item:hover {
  transform: translateY(-5px);
}

.accessory-image {
  width: 100%;
  height: 120px;
  overflow: hidden;
  flex-shrink: 0;
}

.accessory-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.accessory-item:hover .accessory-image img {
  transform: scale(1.05);
}

.accessory-info {
  padding: 12px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.accessory-info h4 {
  font-size: 14px;
  color: #333;
  margin: 0 0 6px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.accessory-info p {
  font-size: 12px;
  color: #666;
  line-height: 1.5;
  margin: 0;
  flex: 1;
}

/* 无配件提示样式 */
.no-accessories {
  margin: 30px 0 50px;
  padding: 20px;
  text-align: center;
  color: #999;
  font-size: 14px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

/* 悬浮询盘按钮样式 */
.floating-inquiry-btn {
  position: fixed;
  right: 30px;
  bottom: 50px;
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #1890ff;
  color: #fff;
  padding: 12px 20px;
  border-radius: 30px;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 999;
}

.floating-inquiry-btn:hover {
  background-color: #096dd9;
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(24, 144, 255, 0.4);
}

.floating-inquiry-btn .icon {
  font-size: 18px;
}

.floating-inquiry-btn .text {
  font-size: 14px;
  font-weight: 500;
}

/* 响应式适配（核心修改：增大小屏幕大图和视频高度） */
@media (max-width: 1200px) {
  .accessory-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
  }
}

@media (max-width: 768px) {
  .pdt-image-body {
    flex-direction: column;
    gap: 20px;
  }

  /* 平板竖屏：大图高度从450px → 550px */
  .pdt-image-show {
    height: 550px;
    margin-bottom: 15px;
    padding: 15px; /* 增加内边距，图片显示更舒适 */
  }

  .pdt-image-show img {
    padding: 15px;
  }

  /* 同步更新视频高度：550(大图)+15(间距)+80(小图)+10(小图内边距) = 655px */
  .product-video {
    height: 655px;
  }

  .pdt-image-mini .xiaotu {
    width: calc(50% - 5px);
    height: 90px; /* 小屏幕增大小图高度，更易点击 */
  }

  .product-detail-section, .product-accessories-section {
    padding: 20px;
  }

  .accessory-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  .accessory-image {
    height: 100px;
  }

  .floating-inquiry-btn {
    right: 20px;
    bottom: 30px;
    padding: 10px 16px;
  }

  .floating-inquiry-btn .text {
    display: none;
  }
}

@media (max-width: 480px) {
  .product-list-body {
    padding: 15px;
  }

  /* 手机端：大图高度从220px → 350px（大幅增大） */
  .pdt-image-show {
    height: 350px;

    margin-bottom: 15px;
    padding: 10px;
  }

  .pdt-image-show img {
    padding: 10px;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  /* 同步更新视频高度：350(大图)+15(间距)+80(小图)+10(小图内边距) = 455px */
  .product-video {
    height: 455px;
  }

  .pdt-image-mini .xiaotu {
    width: calc(50% - 5px);
    height: 80px;
    aspect-ratio: 1/1;
  }

  .list-title h3 {
    font-size: 20px;
  }

  .detail-title h3 {
    font-size: 18px;
  }

  .technical-specs th, .technical-specs td {
    padding: 10px 8px;
    font-size: 13px;
  }

  .accessory-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .accessory-image {
    height: 140px;
  }

  .accessory-info h4 {
    font-size: 15px;
  }

  .accessory-info p {
    font-size: 13px;
  }
}
</style>
